/* eslint-disable no-param-reassign */
import { isNil, round } from 'lodash';
import { formatDate, formatToOptions, getLangCodeForRegion } from '../../../formatters';
import { Currency } from './Currency';

export default i18n => (value, format, lang = i18n.language, params) => {
  const newLang = getLangCodeForRegion(lang.split('-')[1]);
  let result = value;

  if (!isNil(value)) {
    if (value instanceof Date) {
      if (!Number.isNaN(value.getTime())) {
        result = formatDate(value, lang, formatToOptions(format));
      } else {
        result = i18n.t('components:date.invalid');
      }

      return result;
    }

    if (value instanceof Currency) {
      result = value.format(newLang);

      return result;
    }

    if (typeof value === 'number') {
      if (params && params.toFixed) {
        result = round(value, params.toFixed).toLocaleString(newLang, {
          minimumFractionDigits: params.toFixed,
        });
      } else {
        result = round(value, 2).toLocaleString(newLang);
      }

      return result;
    }
  }

  return result;
};
